import _ from 'lodash';
import * as mobx from 'mobx';
import { handleError, IMessageDetail, RootStore } from 'stores';

export class MessagingPresenter {
    @mobx.observable.ref isOpen: boolean = false;
    @mobx.observable.ref isComposeOpen: boolean = false;
    @mobx.observable.ref isDetailLoading: boolean = false;
    @mobx.observable.ref messageDetails: IMessageDetail | undefined;

    constructor(private rootStore = new RootStore()) {}

    @mobx.action
    public setOpen(isOpen: boolean) {
        this.isOpen = isOpen;

        if (isOpen === false) {
            this.closeDetails();
        }
    }

    @mobx.action
    public setComposeOpen(isComposeOpen: boolean) {
        this.isComposeOpen = isComposeOpen;

        if (isComposeOpen === false) {
            this.closeDetails();
        }
    }

    @mobx.action
    public async openMessage(messageId: string) {
        this.isDetailLoading = true;

        try {
            const detail = await this.rootStore.messageStore.loadMessageDetail(messageId);

            if (!detail || _.isEqual(detail, this.messageDetails)) {
                return;
            }

            mobx.runInAction(() => {
                this.messageDetails = detail;
            });
        } catch (err) {
            handleError(err);
        } finally {
            mobx.runInAction(() => {
                this.isDetailLoading = false;
            });
        }
    }

    @mobx.action
    public closeDetails() {
        this.messageDetails = undefined;
    }
}
